"use client";

import { Flex, GridItem, Icon, Link, SimpleGrid, Text } from "@chakra-ui/react";
import { CategoryButton } from "./CategoryButton";
import { BsArrowRight } from "react-icons/bs";
import { blogLinkBuilder } from "@/_utils";
import { useState, useEffect } from "react";
import { Post } from "@/_services/graphql/models/Posts";

interface BlogHeroProps {
  posts: Post[];
}

export const BlogHero = ({ posts }: BlogHeroProps) => {
  const [selectedPost, setSelectedPost] = useState<Post | null>(null);

  useEffect(() => {
    if (posts?.length > 0) {
      const maxIndex = Math.min(posts.length - 1, 4);
      const randomIndex = Math.floor(Math.random() * (maxIndex + 1));
      setSelectedPost(posts[randomIndex]);
    }
  }, [posts]);

  if (!selectedPost || !selectedPost.mainImage?.asset?.url) return null;

  return (
    <Flex
      bgImage={`url(${selectedPost.mainImage.asset.url})`}
      w="100%"
      h={{ base: "30dvh", md: "70dvh" }}
      bgSize={{ base: "contain", md: "cover" }}
      borderRadius="4xl"
      alignItems="flex-end"
      id="blog-hero"
      shadow="shadow-xl"
    >
      <SimpleGrid
        columns={8}
        gap={2}
        w="full"
        alignContent="end"
        p="6"
        pt={10}
        borderBottomRadius="4xl"
        bg="linear-gradient(0deg, rgb(63, 63, 63), rgba(185, 185, 185, 0));"
        backdropFilter="blur(1px)"
      >
        <GridItem colSpan={6} color="white">
          <CategoryButton
            category={
              selectedPost.categories?.length
                ? selectedPost.categories[0].name
                : "Uncategorized"
            }
          />
          <Text
            color="inherit"
            textStyle={{ base: "xl", md: "3xl" }}
            fontFamily="heading"
            fontWeight="light"
            mt={4}
          >
            {selectedPost.title}
          </Text>
          <Text
            display={{ base: "none", md: "block" }}
            color="inherit"
            textStyle="sm"
            fontWeight="light"
            fontFamily="body"
            mt={4}
          >
            {selectedPost.shortDescription}
          </Text>
        </GridItem>
        <GridItem colSpan={2} alignItems="flex-end">
          <Flex align="flex-end" justifyContent="flex-end" h="full">
            <Link
              href={blogLinkBuilder(selectedPost.slug?.current ?? "")}
              style={{ borderBottom: "none" }}
            >
              <Icon
                boxSize={{ base: "3rem", md: "4rem" }}
                fill="white"
                transition="transform .5s"
                cursor="pointer"
                _hover={{ transform: "translateX(1rem)" }}
              >
                <BsArrowRight />
              </Icon>
            </Link>
          </Flex>
        </GridItem>
      </SimpleGrid>
    </Flex>
  );
};
